import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon74: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M13.5 0a4 4 0 0 1 3.969 3.5H19.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H19v6.683c0 2.063-1.884 3.711-4.216 3.809l-.22.005H11.53L11.5 20h-3l-.03-.001-3.034-.002C3.003 19.997 1 18.31 1 16.183V9.5H.5a.5.5 0 0 1-.492-.41L0 9V4a.5.5 0 0 1 .5-.5h2.031a4 4 0 0 1 7.47-1.435A3.991 3.991 0 0 1 13.5 0ZM8 9.5H2v6.683c0 1.533 1.521 2.814 3.436 2.814H8V9.5Zm3-5H9v14.497h2V4.5Zm7 5h-6v9.497h2.564c1.849 0 3.331-1.194 3.431-2.656l.005-.158V9.5Zm1-5h-7v4h7v-4Zm-11 0H1v4h7v-4Zm1.459-1a3 3 0 0 0-5.918 0h5.918ZM13.5 1a3 3 0 0 0-2.959 2.5h5.918A3 3 0 0 0 13.5 1Z"
      />
    </Svg>
  )
}
